import { NgModule } from '@angular/core';
import { NgSelectizeComponent } from './ng-selectize.component';

@NgModule({
  declarations: [NgSelectizeComponent],
  exports: [NgSelectizeComponent]
})
export class NgSelectizeModule { }
